export default {"src":"/_next/static/media/ad.37939c6d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};